<template>
    <div class="py-4 px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 flex align-items-center justify-content-between relative lg:static">
            <Link href="/" style="flex">
                  <img v-if="setting.company_logo == 'none'" v-bind:src="'/images/logo-hris-website.png'" alt="Sakai Logo" height="50" class="mr-0 lg:mr-2">
                  <img v-if="setting.company_logo != 'none'" :src="setting.company_logo" :alt="setting.company_name" height="50" class="mr-0 lg:mr-2">
            </Link>
            <a class="cursor-pointer block lg:hidden text-700 p-ripple" v-ripple
                v-styleclass="{ selector: '@next', enterClass: 'hidden', leaveToClass: 'hidden', hideOnOutsideClick: true }">
                <i class="pi pi-bars text-4xl"></i>
            </a>
            <div class="surface-0 align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full left-0 px-6 lg:px-0 z-2" style="top:92%">
                <div></div>
                <div class="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">

                    <Button v-if="!$page.props.user" @click="login" label="Login" class="p-button-text p-button-rounded border-none font-light line-height-2 text-blue-500"></Button>
                    <Button v-if="$page.props.user" @click="redirect" label="Dashboard" class="p-button-text p-button-rounded border-none font-light line-height-2 text-blue-500"></Button>
                    <!-- <Button @click="register" label="Register" class="p-button-rounded border-none ml-5 font-light text-white line-height-2 bg-blue-500"></Button> -->
                </div>
            </div>
        </div>
</template>
<script>
import Button from 'primevue/button';
import { Link } from '@inertiajs/inertia-vue3';
import Ripple from "primevue/ripple";
export default {
    components: {
        Link,
        Button,
        Ripple,
    },
    props:['setting'],
    methods: {
        smoothScroll(id) {
            document.querySelector(id).scrollIntoView({
                behavior: "smooth",
            });
        },
        login() {
            this.$inertia.get("/login");
        },
        register() {
            this.$inertia.get("/register");
        },
        redirect() {
            this.$inertia.get("/redirect-after-login");
        }
    },
}
</script>
